module.exports = __webpack_public_path__ + "Class@2x.1af51552.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Class/images/Class@2x.png
// module id = uNdX
// module chunks = 0